// L+TV signature programs showcase — rebuilt from the channel program flyer.
// These describe the channel's flagship programs and their everyday value.

export interface ShowcaseProgram {
  id: string;
  icon: string;
  title: string;
  titleEn: string;
  tagline: string;
  description: string;
  schedule: string;
  accent: string;
}

export const programShowcase: ShowcaseProgram[] = [
  {
    id: "grand-matin",
    icon: "ri-sun-line",
    title: "Le Grand Matin sur L+TV",
    titleEn: "The Big Morning",
    tagline: "L'actualité dès le réveil",
    description:
      "Une émission du réveil qui informe, éclaire et accompagne vos matinées : actualité, débats, chroniques, prises de parole et témoignages au cœur de votre quotidien.",
    schedule: "Chaîne 1 · Matin",
    accent: "from-amber-400 to-orange-500",
  },
  {
    id: "point-quotidien",
    icon: "ri-book-read-line",
    title: "Le Point Quotidien",
    titleEn: "The Daily Point",
    tagline: "La Parole de Dieu pour bien commencer la journée",
    description:
      "Un espace d'éducation, de méditation et de renforcement spirituel, dédié à la parole de Dieu, la méditation et l'inspiration pour bien commencer chaque journée.",
    schedule: "Ouverture des programmes à partir de 6h00",
    accent: "from-amber-400 to-red-500",
  },
  {
    id: "journal-flash",
    icon: "ri-earth-line",
    title: "Le Journal & Le Flash Info",
    titleEn: "The News & Info Flash",
    tagline: "L'information en cœur de votre quotidien",
    description:
      "L'information en cœur de votre quotidien : actualité locale, nationale et internationale traitée en quelques minutes. Flash info, actualité internationale et actualité locale en continu.",
    schedule: "À chaque édition",
    accent: "from-sky-400 to-blue-600",
  },
  {
    id: "samedi-jeunes",
    icon: "ri-team-line",
    title: "Samedi des Jeunes",
    titleEn: "Saturday for Youth",
    tagline: "La jeunesse prend le devant !",
    description:
      "Une émission conçue spécialement pour les jeunes, avec des débats, témoignages, orientations, jeux et divertissements. Un espace de réflexion et de découverte de soi.",
    schedule: "Tous les samedis à partir de 15h00",
    accent: "from-rose-300 to-pink-500",
  },
  {
    id: "panorama-sport",
    icon: "ri-football-line",
    title: "Panorama Sport Infos",
    titleEn: "Sport Panorama Info",
    tagline: "Toute l'actualité sportive",
    description:
      "Toute l'actualité sportive : résultats, compétitions, analyses, débats, portraits et performances des sportifs et des équipes. Le sport toujours plus près de vous.",
    schedule: "Toute l'actualité sportive",
    accent: "from-green-400 to-emerald-600",
  },
  {
    id: "face-realites",
    icon: "ri-chat-3-line",
    title: "Face aux Réalités",
    titleEn: "Facing Realities",
    tagline: "Les sujets de société au cœur du débat",
    description:
      "Les sujets de société au cœur du débat. La télévision qui informe, éduque et éveille : famille, jeunesse, éducation, société, santé et problématiques de société.",
    schedule: "Chaque semaine",
    accent: "from-violet-400 to-purple-600",
  },
  {
    id: "weekend-artiste",
    icon: "ri-mic-line",
    title: "Le Week-end avec un Artiste",
    titleEn: "The Weekend with an Artist",
    tagline: "Quand la culture rencontre la télévision",
    description:
      "Quand la culture rencontre la télévision : musique, culture, humour, danse et entretiens. La scène musicale et artistique qui fait vivre la culture et les talents.",
    schedule: "Le week-end",
    accent: "from-fuchsia-400 to-pink-600",
  },
  {
    id: "createurs-valeur",
    icon: "ri-lightbulb-line",
    title: "Les Créateurs de Valeur",
    titleEn: "The Value Creators",
    tagline: "Des parcours qui inspirent, des idées qui transforment",
    description:
      "Des parcours qui inspirent, des idées qui transforment. Inspirer, entreprendre, créer et transformer à travers des récits de valeur et des idées novatrices.",
    schedule: "Émissions dédiées",
    accent: "from-orange-400 to-amber-600",
  },
  {
    id: "au-feminin",
    icon: "ri-heart-3-line",
    title: "Au Féminin",
    titleEn: "Feminine Voices",
    tagline: "La parole aux femmes",
    description:
      "Une émission dédiée exclusivement aux femmes, à leurs parcours, leurs rêves, leurs réussites et leurs aspirations. Société, santé, entrepreneuriat et éducation.",
    schedule: "Chaque semaine",
    accent: "from-pink-400 to-rose-600",
  },
  {
    id: "viendrai-manger",
    icon: "ri-restaurant-2-line",
    title: "Je Viendrai Manger Midi Chez Toi",
    titleEn: "I'll Come Eat at Your Place at Noon",
    tagline: "La télévision passe à table !",
    description:
      "Une émission culinaire conviviale qui nous fait découvrir les saveurs, les recettes, les traditions et les secrets de la cuisine camerounaise.",
    schedule: "Chaque semaine",
    accent: "from-red-400 to-rose-600",
  },
  {
    id: "regard-croise",
    icon: "ri-discuss-line",
    title: "Regard Croisé",
    titleEn: "Crossed Views",
    tagline: "Des regards, plusieurs opinions, un débat",
    description:
      "Des regards, plusieurs opinions, un débat. Actualité politique, gouvernance, société, économie et grands sujets débattus en toute objectivité.",
    schedule: "Chaque semaine",
    accent: "from-slate-500 to-slate-700",
  },
];

export const showcaseTagline = {
  title: "La Télévision du Quotidien",
  subtitle: "Informe · Éduque · Divertit · Rassemble",
  intro:
    "L+TV, une chaîne proche de vous, proche de votre quotidien. Des rendez-vous qui rythment la vie des familles : informations, émissions, sports, divertissements, culture et partage.",
};